import React, { createContext } from 'react';

const LastCheckedContext = createContext();

export default LastCheckedContext;
